import React, { useEffect, useState } from 'react'
import Otp from './Otp';
import { Footer, LoginLayout } from '../commonComponents';
import { Box, AppBar, CardMedia, Stack, Paper, Typography, Divider, Button, useTheme, LinearProgress } from '@mui/material';
import { useHistory, useRouteMatch } from 'react-router';
import ConsentInfo from './ConsentInfo';
import ConsentExpired from './ConsentExpired';
import ConsentVerified from './ConsentVerified';
import { GetConsentOtp, GetConsentOtpBody, GetCurrentConsentApplication, GetCurrentConsentApplicationBody } from '../../redux-store/actions/otpConsent';
import { useDispatch } from 'react-redux';
import { maskPAN } from '../../utils/utilityFunctions';

function ConsentOtp(): JSX.Element {
  const history = useHistory();
  const [showOtp, setShowOtp] = useState<boolean>(false);
  const [isExpired, setIsExpired] = useState<boolean>(false);
  const [isVerified, setIsVerified] = useState<boolean>(false);
  const theme = useTheme();
  const { params } = useRouteMatch();
  const { userId, referenceId, id } = params as unknown as { id: string, userId: string, referenceId: string };
  const [pageLoading, setPageLoading] = useState<boolean>(false);
  const [applicationId, setApplicationId] = useState<string>('');
  const [isJointHolder, setIsJointHolder] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [currentApplicationData, setCurrentApplicationData] = useState<Partial<GetCurrentConsentApplicationBody>>({});
  const [otpResponse, setOtpResponse] = useState<Partial<GetConsentOtpBody>>({});
  const [numberOfTries, setNumberOfTries] = useState<number>(0);
  const [uuid, setuuid]=useState<string>('')


  useEffect(() => {
    (async () => {
      try {
        setPageLoading(true);
        const response = await dispatch(GetCurrentConsentApplication({ applicantId: id, referenceId })) as unknown as GetCurrentConsentApplicationBody;
        if (response?.name && !response?.isConsentVerified) {
          setPageLoading(false);
          setCurrentApplicationData({
            ...response,
            panNo: maskPAN(response?.panNo ?? ''),
            primaryHolderPan: maskPAN(response?.primaryHolderPan ?? ''),
            secondHolderPan: maskPAN(response?.secondHolderPan ?? ''),
          });
          setApplicationId(response?.id ?? '');
          setIsJointHolder(response?.applicant_type != '1');
          setuuid(response?.uuid ?? '');
        } else if (response?.name && response?.isConsentVerified) {
          setCurrentApplicationData({
            ...response,
            panNo: maskPAN(response?.panNo ?? ''),
            primaryHolderPan: maskPAN(response?.primaryHolderPan ?? ''),
            secondHolderPan: maskPAN(response?.secondHolderPan ?? ''),
          });
          setIsJointHolder(response?.applicant_type != '1');
          setIsVerified(true);
          setPageLoading(false);
        }
        if (!response?.isSuccess) {
          setIsExpired(true);
          setPageLoading(false);
          return;
        }
      } catch (e) {
        console.error((e as Error).message);
        setIsExpired(true);
        setPageLoading(false);
      }
    })()
  }, [referenceId]);

  const handleSendOtp = async () => {
    try {
      const response = await dispatch(GetConsentOtp({ applicantId: id, referenceId: uuid })) as unknown as GetConsentOtpBody;
      if (response?.phone) {
        setShowOtp(true);
        setOtpResponse(response);
        setNumberOfTries(response?.numberOfOTPTries ?? 0);
      }
    } catch (e) {
      console.error((e as Error).message);
    }
  }

  return (
    <Stack
      sx={{
        minHeight: '100vh',
        // background: '#f2f6f8 url("/images/abcl-newbg.svg")',
        backgroundSize: 'cover',
      }}
    >
      <AppBar elevation={0} position="static" sx={{ bgcolor: 'transparent' }}>
        <Box>
          <CardMedia
            component="img"
            onClick={() => history.push('/')}
            src="/images/abcl-wealth-logo.svg"
            alt="Logo"
            sx={{
              margin: "15px 0px 0px 15px",
              cursor: 'pointer',
              width: '12rem',
            }}
          />
        </Box>
      </AppBar>
      <Box
        component="main"
        sx={{
          flex: 1,
          display: 'grid',
          placeItems: 'center',
          padding: '15px'
        }}
      >
        {pageLoading && (
          <Paper
            elevation={3}
            sx={{
              p: 4,
              maxWidth: 600,
              width: '100%',
              borderRadius: '16px',
              textAlign: 'center',
              backgroundColor: 'background.default',
              boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
            }}
          >
            <Typography variant="h5" fontWeight={600} sx={{ mt: 1, mb: 2, color: 'primary.main', }}>
              Consent for Adding Joint Holder
            </Typography>
            <LinearProgress />
          </Paper>
        )
        }

        {!pageLoading && isExpired &&
          <ConsentExpired />
        }
        {!pageLoading && isVerified && <ConsentVerified currentApplicationData={currentApplicationData} />}
        {!pageLoading && !isExpired && !isVerified && (!showOtp ? (
          <ConsentInfo
            showOtp={showOtp}
            handleSendOtp={handleSendOtp}
            currentApplicationData={currentApplicationData}
            isJointHolder={isJointHolder}
          />
        ) : (
          <Otp
            setIsVerified={setIsVerified}
            userId={userId}
            id={id}
            otpResponse={otpResponse}
            // referenceId={referenceId}
            referenceId={uuid} //taking uuid response from getcurrentconsentapplication api not from path params
            setShowOtp={setShowOtp}
            setOtpResponse={setOtpResponse}
            numberOfTries={numberOfTries}
            setNumberOfTries={setNumberOfTries}
          />
        ))}
      </Box>
      <Footer />
    </Stack>

  )
}

export default ConsentOtp;
